export const selectHeaders = (reportType) =>
  ({
    sellsByUser: [
      "Producto",
      "Detalle",
      "Subcat/IMEI/ICCID/ PAGO",
      "Código de barras",
      "Precio de venta",
      "Desc.",
      "Fecha de venta",
      "Lote",
    ],
    sellsBySite: [
      "Producto",
      "Detalle",
      "Subcat/IMEI/ICCID/ PAGO",
      "Código de barras",
      "Precio de venta",
      "Desc.",
      "Vendedor",
      "Fecha de venta",
      "Lote",
    ],
    globalSells: [
      "Sucursal",
      "Producto",
      "Detalle",
      "Subcat/IMEI/ICCID/ PAGO",
      "Código de barras",
      "Precio de venta",
      "Desc.",
      "Vendedor",
      "Fecha de venta",
      "Lote",
    ],
  }[reportType]);
